import axios from "axios";

import { config } from "../consts/constants";

const NovaAPI = axios.create({
  baseURL: config.url.API_URL,
});

NovaAPI.interceptors.request.use((request) => {
  request.headers["X-Client-Platform"] = "web";

  return request;
});

export default NovaAPI;
